<div class="container-fluid">
  <div class="row cm__main">
    <div class="cm__user-info">
      <div class="cm__user-info__avatar">
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
          width="50"
          height="50"
          class="svg-inline--fa fa-user fa-w-14 fa-3x"
        >
          <path
            fill="currentColor"
            d="M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
          ></path>
        </svg>
      </div>

      <div class="cm__mfa">
        <h1 class="cm__mfa__title">Forgot password</h1>

        <form [formGroup]="forgotPasswordForm" class="cm__form cm__form--inverse js-form" action="" autocomplete="off">
          <div class="cm__form__row">
            <label class="cm__form__input-label cm__form__item">
              <div class="cm__form__label-text"><span>Username:</span></div>
              <div class="cm__form__icon" role="img" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 13" fill="none">
                  <g clip-path="url(#clip0)">
                    <path
                      d="M5.5 6.23333C7.23594 6.23333 8.64286 4.83814 8.64286 3.11667C8.64286 1.3952 7.23594 0 5.5 0C3.76406 0 2.35714 1.3952 2.35714 3.11667C2.35714 4.83814 3.76406 6.23333 5.5 6.23333ZM7.7 7.0125H7.28996C6.74487 7.26086 6.13839 7.40208 5.5 7.40208C4.86161 7.40208 4.25759 7.26086 3.71004 7.0125H3.3C1.47812 7.0125 0 8.47831 0 10.285V11.2979C0 11.9432 0.527902 12.4667 1.17857 12.4667H9.82143C10.4721 12.4667 11 11.9432 11 11.2979V10.285C11 8.47831 9.52187 7.0125 7.7 7.0125Z"
                      fill="white"
                      fill-opacity="0.6"
                    ></path>
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="11" height="12.4667" fill="white"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <input type="text" class="cm__form__input js-form-input is-required" formControlName="userName" />
            </label>
          </div>
          <div class="cm__form__row cm__form__failure" role="alert"></div>
          <div class="cm__form__row">
            <button
              type="button"
              (click)="onSubmit()"
              class="cm__button cm__button--arrow cm__button--secondary cm__button--small js-form-submit"
            >
              <span>Send reset code</span>
            </button>
          </div>
          <div class="cm__form__row">
            <a href="javascript:void(0)" (click)="backToSignin()" class="link cm-signin">Back to Log In</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
